module.exports = __webpack_public_path__ + "static/media/BoundWorx_Part_B_SDS.b8e891b2.pdf";